function subtaskDetailsDialog () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/subtask-details/subtask-details-dialog.html?$$REVISION$$'
  }
}

export { subtaskDetailsDialog }
